class AccountInfoModel {
    constructor(model, mobile) {
        this.userInfo = model.userInfo
        this.userInfo.mobile = mobile
        this.result = model.result
    }

    //无论是否完善信息，都要跳完善信息页面
    get isAccountInfoComplete() {
        return false
    }
}

export { AccountInfoModel }
